// src/components/ui/modal/newsModal.js
// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';

const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 40vw;

    @media (max-width: 1200px) {
      max-width: 65vw;
    }

    @media (max-width: 768px) {
      max-width: 95vw;
    }
  }

  .modal-content {
    background-image: url('/assets/ui/container-main-bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    color: #fff;
    border-radius: 8px;
    padding: 15px;
    overflow: hidden;
  }

  .modal-header .btn-close {
    filter: invert(1);
    opacity: 1;
  }
`;

// 🟢 Modal Footer - Buttons bleiben nebeneinander
const StyledModalFooter = styled(Modal.Footer)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;
  padding: 15px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

// 🟢 Allgemeiner Button für Navigation & Schließen
const StyledButton = styled.button`
  background-color: #ffcc00;

  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  flex: 1; /* Alle Buttons gleich groß machen */
  max-width: 120px;
  text-align: center;

  &:hover {
    background-color: #ffd633;
  }

  &:disabled {
    background-color: #555;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    max-width: 100px;
    font-size: 12px;
  }
`;

// 🟢 Markdown Styling für lange Texte
const StyledMarkdown = styled(ReactMarkdown)`
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  display: block;
  max-width: 100%;
  margin-top: 1rem;

  img {
    max-width: 100%;
    height: auto;
  }

  pre {
    white-space: pre-wrap !important;
    overflow-x: auto;
    padding: 10px;
    border-radius: 5px;
  }
`;

// 🟢 Modal Body Styling für bessere Lesbarkeit
const StyledModalBody = styled(Modal.Body)`
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 15px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
`;

// 🟢 Image Styling für optimale Darstellung
const StyledImg = styled.img`
  width: 100%;
  max-height: 300px;
  object-fit: contain;
  border-radius: 8px;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    max-height: 200px;
  }
`;

const NewsModal = ({ show, onHide, news, allNews, setSelectedNews }) => {
  const { t } = useTranslation();
  if (!news) return null;

  const currentIndex = allNews.findIndex((n) => n.id === news.id);

  const handleNext = () => {
    if (currentIndex < allNews.length - 1) {
      setSelectedNews(allNews[currentIndex + 1]);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setSelectedNews(allNews[currentIndex - 1]);
    }
  };

  return (
    <StyledModal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{news.title}</Modal.Title>
      </Modal.Header>
      <StyledModalBody>
        <StyledImg src={news.image} alt={news.title} />
        <div>{news.dateTime || t('newsModal.noDate')}</div>
        <StyledMarkdown>{news.fullContent}</StyledMarkdown>
      </StyledModalBody>
      <StyledModalFooter>
        <StyledButton onClick={handlePrev} disabled={currentIndex === 0}>
          {t('newsModal.previous')}
        </StyledButton>
        <StyledButton onClick={onHide}>{t('newsModal.close')}</StyledButton>
        <StyledButton onClick={handleNext} disabled={currentIndex === allNews.length - 1}>
          {t('newsModal.next')}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};

export default NewsModal;
